import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TopicById } from './index';

export interface TopicByIdGetParams {
  id: string;
}

export const topicById = (payload: TopicByIdGetParams): Action<TopicByIdGetParams> => ({
  type: actions.topicByIdTrigger.toString(),
  payload,
});

export const topicByIdClear = (): Action => ({
  type: actions.topicByIdClear.toString(),
});

export const topicByIdErrorClear = (): Action => ({
  type: actions.topicByIdErrorReset.toString(),
});

export function* topicByIdRequestSaga({ payload }: Action<TopicByIdGetParams>) {
  yield put({
    type: actions.topicByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.topicByIdError.toString(),
      payload: {
        message: 'TopicById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/topics/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TopicById, TopicById>(
    response,
    actions.topicByIdSuccess.toString(),
    actions.topicByIdError.toString(),
    false,
    (topicByIdData) => topicByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.topicByIdTrigger.toString(),
    defaultProcessingSaga(
      topicByIdRequestSaga,
      {
        error: actions.topicByIdError.toString(),
        locationCancel: actions.topicByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.topicByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.topicByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.topicByIdErrorReset.toString(),
    });
  });
}
